/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * field to filter for partner operator search:
 *   * ALL : All fields
 *   * NAME
 */
export enum PartnerOperatorSearchFilter {
  ALL = 'ALL',
  NAME = 'NAME'
}
